module.exports = __webpack_public_path__ + "fb1.svg";